'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'parachute-box';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f4cd';
var svgPathData = ['M0 232l80.4 0 117.1 93.7c8.1-3.7 17-5.7 26.5-5.7l8 0 0-88 48 0 0 88 8 0c9.4 0 18.4 2 26.5 5.7L431.6 232 512 232 347.7 360.8c2.8 7.2 4.3 15 4.3 23.2l0 64c0 35.3-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64l0-64c0-8.2 1.5-16 4.3-23.2L0 232z', 'M128 224C128 152.2 144.3 88.4 169.5 43.4 195.1-2.4 226.6-24 256-24s60.9 21.6 86.5 67.4C367.7 88.4 384 152.2 384 224l0 8-256 0 0-8zm-48 8l-80 0 0-24C0 104.2 61.3 24.9 147.8-10.9 140.5-1.4 133.7 9 127.6 20 97.7 73.4 80 145.6 80 224l0 8zm352 0l0-8C432 145.6 414.3 73.4 384.4 20 378.3 9 371.5-1.4 364.2-10.9 450.7 24.9 512 104.2 512 208l0 24-80 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faParachuteBox = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;